import { Picker } from 'emoji-mart'
import { useCallback, useEffect, useRef, useState } from 'react'

import { doesSupportEmoji } from '../../utils/helpers'
import styles from './EditTextDialog.module.scss'
import { ReactComponent as EmojiIcon } from './emoji.svg'

const EmojiPicker = ({ show, className, winClassName, onSelect, ref }) =>
  show ? (
    <div
      className={navigator.appVersion.indexOf('Win') !== -1 ? winClassName : className}
      ref={ref}
    >
      <Picker
        set="apple"
        native={doesSupportEmoji()}
        onSelect={onSelect}
        showPreview={false}
        showSkinTones={false}
        autoFocus={true}
      />
    </div>
  ) : null

export const EmojiPickerContainer = ({ onSelect, onOpen }) => {
  const containerRef = useRef()
  const [showEmojiPicker, setShowEmojiPicker] = useState()
  function handleSelectEmoji(emoji) {
    setShowEmojiPicker(false)
    onSelect(emoji.native)
  }
  const handleClickOutsideEmojiButton = useCallback(e => {
    if (containerRef.current.contains(e.target)) {
      return
    }
    setShowEmojiPicker(false)
  }, [])
  useEffect(() => {
    if (showEmojiPicker) {
      onOpen()
      document.addEventListener('mousedown', handleClickOutsideEmojiButton)
    } else {
      document.removeEventListener('mousedown', handleClickOutsideEmojiButton)
    }
    return () => document.removeEventListener('mousedown', handleClickOutsideEmojiButton)
  }, [handleClickOutsideEmojiButton, onOpen, showEmojiPicker])
  return (
    <div ref={containerRef} className={styles.emojiContainer}>
      <button
        className={styles.emojiButton}
        onClick={() => setShowEmojiPicker(!showEmojiPicker)}
      >
        <EmojiIcon />
      </button>
      <EmojiPicker
        show={showEmojiPicker}
        onSelect={handleSelectEmoji}
        className={styles.emojiPicker}
        winClassName={styles.emojiPickerWin}
      />
    </div>
  )
}
